<template>
  <div class="selection">
    <dx-description-label v-if="$te(`${translationKeyPrefix}.description`)">
      {{ $t(`${translationKeyPrefix}.description`) }}
    </dx-description-label>
    <dx-radio-buttons
      :id="config.id"
      :options="config.options"
      :value="value"
      :error="translatedError"
      @change="update"
      @blur="onBlur"
    />
  </div>
</template>

<script>
import { DxRadioButtons } from '@sumcumo/dextra-frontend-component-lib'
import DxDescriptionLabel from '~/components/DX-DescriptionLabel/DxDescriptionLabel'

export default {
  name: 'DXRadioGroupAdapter',
  components: {
    DxDescriptionLabel,
    DxRadioButtons,
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mappedRadioOptions() {
      return this.config.options.map((option) => ({
        value: option.value,
        name: this.$t(`${this.translationKeyPrefix}.options.${option.name}`),
      }))
    },

    translationKeyPrefix() {
      if (this.config.source) {
        if (this.config.source.kind === 'values') {
          return `attributes.${this.config.source.key}.${this.config.source.originalId}`
        }

        return `${this.config.source.key}.${this.config.source.originalId}`
      }

      return ''
    },

    translatedLabel() {
      return this.$t(`${this.translationKeyPrefix}.label`)
    },

    translatedError() {
      return this.error
        ? this.$t(`errors.${this.error.type}`, {
            ...this.error.params,
            label: this.translatedLabel,
          })
        : null
    },
  },
  methods: {
    update(newValue) {
      this.$emit('input', [newValue])
    },
    onBlur() {
      this.$emit('validate', this.config.id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/colors';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/typo';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/functions/px-to-rem';

.selection {
  display: block;
  width: 100%;

  ::v-deep {
    .button {
      display: flex;
      border-color: $color-turquoise-surf;
      justify-content: center;
      align-items: center;
      background: $white-clr;
    }
    .radioInput ~ .text {
      border: 1px solid $color-turquoise-surf;
      border-radius: rem(20);
      padding: rem(12) rem(16);
      min-width: rem(96);
      background: $white-clr;
      color: $color-turquoise-surf;
      line-height: 1;
    }
    .buttonChecked,
    .button:hover,
    .button:active,
    .button:focus {
      .text {
        background: $color-turquoise-surf;
        color: $white-clr;
      }
    }
  }
}
</style>
